// Capture user's page lang to hidden field

import GravityForms from './component.js'


// Set's the web source field to the location

class webSource extends GravityForms {
  constructor() {
    super()
    let form = this.form
    if (form) {
      let field = form.querySelector('[id="SFGA__Web_Source__c"]')
      let url = this.source
      if (field) {
        field.value = url
      }
    }
  }

  get source () {
    // Prioritise which URL is recorded as:
    // 1. If the current page has any UTM paramaters in it
    // 2. If the user has a stored 'gclid' URL (Stored under localStorage 'sm-sem-click')
    // 3. The current URL
    const sem = localStorage.getItem('sm-sem-click')

    if (sem) {
      return sem
    } else {
      return location.href
    }
  }
}

new webSource()


// WEBPACK FOOTER //
// ./scripts/routes/gravity-forms/webSource.js